import React from "react";
import { TableBody, TableCell, TableRow, Typography } from "@mui/material";

import { materialsStyles } from "../../styles/materials/materialsTableStyles";
import {
  CM_DELIVERY_DATE,
  CM_DELIVERY_PERIOD,
  CM_ERLIEST_DELIVERY_DATE,
  CM_ORDER_DATE,
  CM_PRODUCT_CLIENT_NAME,
  CM_PRODUCT_DESCR,
  CM_PRODUCT_SWD,
  CM_QTY,
  CM_UNIT,
} from "../../utils/consts/materialsConsts";
import {
  formatAbasDate,
  getProperUnit,
  getValue,
} from "../../utils/materialsUtils";

import { NoMaterials } from "./NoMaterials";

const getQtyWithUnit = (qty, unit) => `${getValue(qty)} ${getProperUnit(unit)}`;

const MaterialsRows = ({ materials }) =>
  materials.map((material, i) => (
    <TableRow key={i + 1}>
      <TableCell sx={materialsStyles.tableBodyCellRowNumber}>
        <Typography sx={materialsStyles.rowNr}>{i + 1}.</Typography>
      </TableCell>

      <TableCell sx={materialsStyles.tableBodyCell}>
        <Typography sx={materialsStyles.materialName}>
          {getValue(material[CM_PRODUCT_CLIENT_NAME])}
        </Typography>
      </TableCell>

      <TableCell sx={materialsStyles.tableBodyCell}>
        <Typography sx={materialsStyles.rowNr}>
          {getValue(material[CM_PRODUCT_SWD])}
        </Typography>
      </TableCell>

      <TableCell sx={materialsStyles.descriptionCell}>
        <Typography sx={materialsStyles.descriptionText}>
          {getValue(material[CM_PRODUCT_DESCR])}
        </Typography>
      </TableCell>

      <TableCell sx={materialsStyles.tableBodyCell}>
        <Typography sx={materialsStyles.rowNr}>
          {getQtyWithUnit(material[CM_QTY], material[CM_UNIT])}
        </Typography>
      </TableCell>

      <TableCell sx={materialsStyles.tableBodyCell}>
        <Typography sx={materialsStyles.rowNr}>
          {formatAbasDate(material[CM_ORDER_DATE])}
        </Typography>
      </TableCell>

      <TableCell sx={materialsStyles.tableBodyCell}>
        <Typography sx={materialsStyles.rowNr}>
          {formatAbasDate(material[CM_DELIVERY_DATE])}
        </Typography>
      </TableCell>

      <TableCell sx={materialsStyles.tableBodyCell}>
        <Typography sx={materialsStyles.rowNr}>
          {formatAbasDate(material[CM_DELIVERY_PERIOD])}
        </Typography>
      </TableCell>

      <TableCell sx={materialsStyles.tableBodyCell}>
        <Typography sx={materialsStyles.rowNr}>
          {formatAbasDate(material[CM_ERLIEST_DELIVERY_DATE])}
        </Typography>
      </TableCell>
    </TableRow>
  ));

export const MaterialsTableBody = ({ materials }) => (
  <TableBody>
    {materials == null || materials.length === 0 ? (
      <NoMaterials />
    ) : (
      <MaterialsRows materials={materials} />
    )}
  </TableBody>
);
